import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--chat-background);
  width: 100%;
  padding: 0 0 10px 0;
  height: 100%;
  
  @media (max-width: 768px) {
    height: 80%;
    overflow-y: scroll;
    padding-bottom: 60vh;
  }

  .AttendantHeader{
    width: 100%;
    height: 100px;
    background-color: var(--dark-blue);
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--white);

    span{
      font-size: 24px;
      font-weight: 300;
      line-height: 28px;
      font-family: roboto, sans-serif;
      margin-right: 20px;
    }
    img {
      width: 24px;
      margin: 0 20px;
      cursor: pointer;
      transition: transform 0.1s ease;
      
      &:active {
        transform: scale(0.9);
      }
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
  


`
export const AttendantMenuContainer = styled.div`
  background-color: var(--dark-blue);
  margin: 0 auto; 
  display: flex;
  flex-direction: column;
  padding: 2% 2% 4% 2%;
  margin: 1rem 2rem ;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);



  .buttonContainer{
    display:flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 70px;
    gap: 10px;
    width: 99%;
  }
  
  .titleContainer {
    display: flex;
    flex-direction: column;
    gap: 1vh;
    
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      color: var(--white);
      font-size: 2.8vh;
      margin-bottom: 2rem;
      font-weight: 300;
      margin-right: 1%;
    }

    .sub {
      font-size: 2vh;
      color: var(--white);
      font-weight: 400;
      margin-bottom: 2rem;
    }
  }

  .AttendantContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .inputContainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      padding: 1%;
      height: auto;
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
      position: relative;
     
      input {
        width: 100%;
        height: 3rem;
        border: 0;
        outline: 0;
        font-weight: 400;
        color: #000 50%;
        outline: none;
        border: none;
        padding: 2% 3%;
      }
    }
    .iconsInput{
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 2%;
      top: 80%;
      transform: translateY(-50%);
      flex-direction: row;
      gap: 10px;
      z-index: 2;
    }
  }

`;

export const CancelButton = styled.button`
  color: var(--blue);
  height: 48px;
  width: 6em;
  padding: 2%;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    transform: scale(0.95);
    box-shadow: rgba(0, 0, 0, 0.2); 
    delay: 0.5s;
  }
`;

export const ConfirmButton = styled.button`
  border: 0;
  outline: 0;
  background-color: var(--blue);
  padding: 2%;
  height: 48px;
  width: 8.125em;
  min-width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--white);
  font-size: 1em;

  &:active {
    transform: scale(0.95);
    box-shadow: rgba(0, 0, 0, 0.2); 
    delay: 0.5s;
  }
`;

export const ChangeMail = styled.button`
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
  font-size: 1em;
  background-color: var(--blue);
  color: white;
  margin-right: 10px;
  outline: none;
  border: none;

  .arrowIcon {
    width: 1rem;
    height: auto;
    margin-right: 20px;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: row;
  }
`;

export const LibrasButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3%;
  font-size: 1em;
  gap: 0.938rem;
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
  background-color: var(--blue);
  color: white;
  border: none;
  outline: none;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }

  @media (max-width: 42.813) {
    font-size: 0.75rem;
    gap: 0.313rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 1rem;
  background-color: var(--primary-blue);
  color: var(--white);
  padding: 1.5rem 2rem;
  width: 100%;

  .back-button {
    position: absolute;
    left: 2rem;
    background: none;
    border: none;
    cursor: pointer;
  }

  h1 {
    font-size: 1.7rem;
    margin: 0;
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
  }
`;